import React from "react";
import { SVG, IconProps } from "../SVG";
export const SpotAlertTriangle = ({
    spotColor = "#FCB5A9",
    color = "#13126C",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
        <path
            fill={spotColor}
            d="M21.534 3.296c-2.007 2.264-1.971 5.507-2.414 8.071-.543 3.086-2.914 5.2-3.929 8.15-1.014 2.95-1.264 6.886-.3 9.622a6.586 6.586 0 0 0 6.3 4.407c3.686 0 7.108-2.672 10.186-4.607a4.17 4.17 0 0 0 2.086-3.029c.359-.45.681-.927.964-1.429a8.307 8.307 0 0 0 .943-5.892 12.59 12.59 0 0 0-1.072-2.808 11.915 11.915 0 0 0-.785-1.371 4.206 4.206 0 0 0 .343-3.964 26.25 26.25 0 0 0-3.608-6.472 2.721 2.721 0 0 0-2.857-2.271 5.521 5.521 0 0 0-5.857 1.593Z"
            opacity={0.8}
        />
        <path
            fill={color}
            fillRule="evenodd"
            d="M17.827 4.3a4.433 4.433 0 0 1 5.965 1.564l.003.005 14.117 23.567.009.015a4.433 4.433 0 0 1-3.79 6.65H5.872a4.433 4.433 0 0 1-3.79-6.65l.008-.015L16.208 5.869l.944.565-.94-.57A4.433 4.433 0 0 1 17.826 4.3Zm.267 2.702-.002.003L3.984 30.558A2.233 2.233 0 0 0 5.892 33.9h28.22a2.233 2.233 0 0 0 1.908-3.343L21.91 7.005l-.001-.003a2.233 2.233 0 0 0-3.816 0ZM19.994 29a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0-18c-1.668 0-2.504 1.625-2.5 3.25v.04c.003 1.712.018 9.71 2.5 9.71 2.5 0 2.503-8.125 2.5-9.75-.004-1.625-.833-3.25-2.5-3.25Z"
            clipRule="evenodd"
        />
    </SVG>
);
SpotAlertTriangle.displayName = "SpotAlertTriangle";
